export default "__VITE_ASSET__B77_LKfw__"